export default __webpack_public_path__ + "static/packagePageImg-7a1c94a81a05d63e6ea1644da9db2703.png";